import {useGraphql} from "@/core/graphql/service"

import {genqlBuilder} from "@/core/graphql/genql/builder"

import {QueryGenqlSelection, Query} from "../schema"

export type QueryFortuneUserPrizeVars = {}

export type FortuneUserPrizeResult = Query['fortune_user_prize']

export function fortuneUserPrizeQuery(query: QueryGenqlSelection['fortune_user_prize'] | null) {
      
    const build = (variables: QueryFortuneUserPrizeVars) => genqlBuilder.build(query ? {fortune_user_prize: query} : {__scalar: true}, {fortune_user_prize: variables})
    const run = (variables: QueryFortuneUserPrizeVars | null = null): Promise<FortuneUserPrizeResult | null> => {
        const {queryWrapped} = useGraphql()
        return queryWrapped(build(variables || {}))
    }
                
    return {
      build,  
      run,
      _variables: {} as QueryFortuneUserPrizeVars,
      _result: {} as FortuneUserPrizeResult,
    }
}

export default fortuneUserPrizeQuery